// extracted by mini-css-extract-plugin
export default {"button":"EditModal_button__yBzLF","divider":"EditModal_divider__TdOsT","link":"EditModal_link__U9+s5"};